<template>
    <el-dropdown trigger="hover" placement="bottom-end" @on-click="menuHandler" class="user-dropdown">
        <img v-if="this.user && this.user.picUrl" :src="this.user.picUrl" class="dropdown-img" alt="">
        <img v-else src="../../../../../assets/topbar_head.svg" class="dropdown-img"/>
        <el-dropdown-menu slot="dropdown">
            <a href="#" class="user-center" @click="menuHandler('user-center')">
                <el-dropdown-item name="user-center">{{this.user ? this.user.userName : ''}}</el-dropdown-item>
            </a>
            <slot></slot>
            <a href="#" class="logout-btn" @click="menuHandler('logout')">
                <el-dropdown-item divided name="logout">{{$translate('component.E1202104125063', { defaultText: '退出' })}}</el-dropdown-item>
            </a>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import { mapGetters } from 'vuex';
import { logout } from '@/utils/index';
import { I18nMixins } from '@/components/utils/i18n';
import bigDataLog from '@/utils/bigDataLog';

export default {
    name: 'User',
    mixins: [I18nMixins],
    data() {
        return {};
    },
    props: {
        targetRoute: {
            type: String,
            default: '/user-center'
        }
    },
    computed: {
        ...mapGetters(['user', 'currentTenant']),
        userCenterPath() {
            // 默认跳转各模块的/user-center页面
            return this.currentTenant ? `//${'localhost.midea.com:8080'}${location.pathname}#${this.targetRoute}` : '';
        }
    },
    methods: {
        menuHandler(name) {
            switch (name) {
            case 'logout':
                logout(true);
                break;
            case 'user-center':
                this.$router.push(this.targetRoute);
                bigDataLog.sendDetailMessageByKey('bigData-btn-header-bar-user');
                break;
            }
        }
    }
};
</script>
<style lang="less">
.user-dropdown {
    margin-right: 20px;
    cursor: pointer;
    display: flex !important;
    align-items: center;
    .dropdown-img{
        width: 25px;
        height: 25px;
        border-radius: 50%;
    }
    .user-name {
        color: #fff;
        cursor: pointer;
    }
    .login-btn,
    .logout-btn {
        color: #fff;
        text-decoration: none;
    }
}

</style>
